<template>
  <button
    type="button"
    class="flex items-center justify-center bg-transparent"
  >
    <IconChevronLeftCircleFilled
      class="size-6 text-primary"
    />
  </button>
</template>

<script setup lang="ts"></script>
